import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import { AssignmentStudent } from '../../../../../../../api/types/assignment-student-details/response/assignment-student-db';

export const deleteStudentIdOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number,
  studentId: number,
  setLoading: (loading: boolean) => any,
  setStudentData: (data: AssignmentStudent[]) => any,
  setStudentDataUpdated: (data: AssignmentStudent[]) => any,
) => {
  try {
    if (isNaN(Number(programId)) || isNaN(Number(courseId))) {
      console.error(
        `Can not find curretn programId: ${programId} and courseId: ${courseId}`,
      );
      toast.warn(
        'לא ניתן לאתר את מזהה התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים',
      );
      return;
    }

    setLoading(true);
    const res = await appApi.deleteStudentAssignmentFile(
      programId!,
      courseId!,
      assignmentId,
      studentId,
    );
    setLoading(false);
    if (res.status === HttpStatusCode.Ok) {
      setStudentData(res.data.body);
      setStudentDataUpdated(res.data.body);
    }
  } catch (e) {
    setLoading(false);

    console.error(
      `deleteStudentIdOperation is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId}, studentId: ${studentId} with the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
